module.exports = __webpack_public_path__ + "img/youbian.a9c4e8a7.png";